import { render, staticRenderFns } from "./ProWorksheetDxTablePivoted.vue?vue&type=template&id=b8d6c80e&scoped=true&"
import script from "./ProWorksheetDxTablePivoted.vue?vue&type=script&lang=js&"
export * from "./ProWorksheetDxTablePivoted.vue?vue&type=script&lang=js&"
import style0 from "./ProWorksheetDxTablePivoted.vue?vue&type=style&index=0&id=b8d6c80e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d6c80e",
  null
  
)

export default component.exports